import { Injectable } from "@nestjs/common";
import { ContractorDto } from "./dto/human-resource-agent.dto";
import { Contractor } from "./entity/human-resource-agent.entity";

@Injectable()
export class ContractorAdapter{

    public convertDtoToEntity(dto: ContractorDto , isUpdate: boolean = false): Contractor{
        const entity = new Contractor();
        
        entity.contractorName = dto.contractorName;
        entity.contractorProId = dto.contractorProId;
        entity.contractorType = dto.contractorType;
        entity.noOfEmployees = dto.noOfEmployees;
        entity.fromDate = dto.fromDate;
        entity.toDate = dto.toDate;
        entity.contractPeriod = dto.contractPeriod;
        entity.updatedAt=dto.updatedAt;
        entity.isActive = dto.isActive === undefined ? true : dto.isActive;
        if(isUpdate){
            entity.contractorId = dto.contractorId;
            entity.updatedUser=dto.updatedUser;
             }else{
                entity.isActive = true;
                entity.createdUser = dto.createdUser;   
             }
        return entity;
    }

    public convertEntityToDto(entity: Contractor): ContractorDto{
        const dto = new ContractorDto();
        dto.contractorId = entity.contractorId;
        dto.contractorName = entity.contractorName;
        dto.contractorProId = entity.contractorProId;
        dto.contractorType = entity.contractorType;
        dto.noOfEmployees = entity.noOfEmployees;
        dto.fromDate = entity.fromDate;
        dto.toDate = entity.toDate;
        dto.contractPeriod = entity.contractPeriod;
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        return dto;

    }
}